export default "__VITE_ASSET__DDoScRH7__"